/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type QuickViewItem_itemSearch = {
    readonly " $fragmentRefs": FragmentRefs<"QuickViewCategoryParagraph_itemSearch">;
    readonly " $refType": "QuickViewItem_itemSearch";
};
export type QuickViewItem_itemSearch$data = QuickViewItem_itemSearch;
export type QuickViewItem_itemSearch$key = {
    readonly " $data"?: QuickViewItem_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"QuickViewItem_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "QuickViewItem_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "QuickViewCategoryParagraph_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = '38658c1c8544061422434729e2162789';
export default node;
